exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* SearchPaginated.css */\n.ui.search .results {\n    width: auto;\n}\n", ""]);

// exports
